module.exports = [{"type":"title","text":"2023-07-29"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"normal","text":"USDT本位永續合約V2下單接口支持限價止盈TAKE_PROFIT/限價止損STOP訂單類型"},{"type":"normal","text":"USDT本位永續合約V2/現貨下單與查詢相關接口支持自定義clientOrderId"},{"type":"normal","text":"現貨支持批量下單"},{"type":"normal","text":"提供現貨Kline接口"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2023-07-29.json
// module id = MfXY
// module chunks = 3